import * as d3Array from 'd3-array';

export const sortByDate = (statsHistory, order) => {
    return order == 'down'
        ? sortAccending(statsHistory, 'testTime')
        : sortDecending(statsHistory, 'testTime');
}

export const sortByBodyWeight = (statsHistory, order) => {
    return order == 'down'
        ? sortAccending(statsHistory, 'analysis.weight.currentValue')
        : sortDecending(statsHistory, 'analysis.weight.currentValue');
}

export const sortByMuscleMass = (statsHistory, order) => {
    return order == 'down'
        ? sortAccending(statsHistory, 'analysis.skeletalMuscleMass.currentValue')
        : sortDecending(statsHistory, 'analysis.skeletalMuscleMass.currentValue');
}

export const sortByBodyFat = (statsHistory, order) => {
    return order == 'down'
        ? sortAccending(statsHistory, 'analysis.percentBodyFat.currentValue')
        : sortDecending(statsHistory, 'analysis.percentBodyFat.currentValue');
}

const getObjectValue = (object, key) => {
    return key.split('.').reduce((o, i) => o[i], object) || '';
}

const sortAccending = (array, key) => {
    return array.sort((a, b) => {
        const aValue = getObjectValue(a, key);
        const bValue = getObjectValue(b, key);
        if (aValue > bValue)
            return -1;
        if (aValue < bValue)
            return 1;
        return 0;
    }); 
}

const sortDecending = (array, key) => {
    return array.sort((a, b) => {
        const aValue = getObjectValue(a, key);
        const bValue = getObjectValue(b, key);
        if (aValue < bValue)
            return -1;
        if (aValue > bValue)
            return 1;
        return 0;
    });
}

export const calculateYAxesTickIndices = (data, formattedRanges) => {
   const sortedYAxisData = data.sort((a, b) => a - b);
   if (formattedRanges) {
    if (formattedRanges[0].start < sortedYAxisData[0] ) {
        sortedYAxisData.unshift(formattedRanges[0].start);
    }
    if (formattedRanges[formattedRanges.length - 1].end > sortedYAxisData[sortedYAxisData.length - 1]) {
        sortedYAxisData.push(formattedRanges[formattedRanges.length - 1].end);
    }
   }
   const ticks = d3Array.ticks(sortedYAxisData[0], sortedYAxisData[sortedYAxisData.length - 1], 30);
   if   (ticks.length % 2 === 0) {
    const diff = ticks[1] - ticks[0];
    ticks.push(ticks[ticks.length - 1] + diff);
   }
   const medianIndex =  Math.ceil((ticks.length - 2 ) / 2);
   return {
        customYAxesTickIndices: [ 0, medianIndex, ticks.length - 1],
        yMin: ticks[0],
        yMax: ticks[ticks.length - 1],
        customTicks: ticks,
    };
};

export const shouldRenderYAxisTickIndex = (indicesToRender , index) => {
    return indicesToRender.findIndex((indexTorender) => (index === indexTorender)) > -1;
};
